@if (loadingSpinnerService.isSpinnerVisible()) {
  <vwui-spinner class="vwui-spinner--with-margin"></vwui-spinner>
}

<div class="main-wrapper">
  @if (!mandateDetails?.preconditions?.constructionCostsNotSpecified.satisfiedOrOptional) {
    <app-explanation [link]="getUriForStep(1)">{{ 'COMPONENT.mandating.cannot_start.construction_costs_not_specified' | translate : { constructionCostsLabel: projectDetails.projectInfo.constructionCostsLabel } }}</app-explanation>
  }
  @if (!mandateDetails?.preconditions?.quickscanNotFilledIn.satisfiedOrOptional) {
    <app-explanation [link]="getUriForStep(2)">{{ 'COMPONENT.mandating.cannot_start.quickscan_not_filled' | translate }}</app-explanation>
  }
  @if (!mandateDetails?.preconditions?.quickscanNotSubmitted.satisfiedOrOptional) {
    <app-explanation [link]="getUriForStep(2)">{{ 'COMPONENT.mandating.cannot_start.project_not_classified' | translate }}</app-explanation>
  }
  @if (!mandateDetails?.preconditions?.tisQuickscanNotSubmitted.satisfiedOrOptional) {
    <app-explanation [link]="getUriForStep(7)">{{ 'COMPONENT.mandating.cannot_start.tis_not_classified' | translate : { tisLabelShort : projectDetails.projectInfo.tisLabelShort } }}</app-explanation>
  }
  @if (!mandateDetails?.preconditions?.tisQuickscanOutdated.satisfiedOrOptional) {
    <app-explanation [link]="getUriForStep(7)">{{ 'COMPONENT.mandating.cannot_start.tis_quickscan_outdated' | translate : { tisLabelShort : projectDetails.projectInfo.tisLabelShort } }}</app-explanation>
  }
  @if (!mandateDetails?.preconditions?.nrOfRisksNotCompliant.satisfiedOrOptional) {
    <app-explanation [link]="getUriForStep(3)">{{ 'COMPONENT.mandating.cannot_start.nr_risks_not_sufficient' | translate }}</app-explanation>
  }
  @if (!mandateDetails?.preconditions?.nrOfOpportunitiesNotCompliant.satisfiedOrOptional) {
    <app-explanation [link]="getUriForStep(4)">{{ 'COMPONENT.mandating.cannot_start.nr_opportunities_not_sufficient' | translate }}</app-explanation>
  }
  @if (!mandateDetails?.preconditions?.tisNotFilledIn.satisfiedOrOptional) {
    <app-explanation [link]="getUriForStep(8)">{{ 'COMPONENT.mandating.cannot_start.tis_not_filled' | translate }}</app-explanation>
  }
  @if (!mandateDetails?.preconditions?.attachmentsRequired.satisfiedOrOptional) {
    <app-explanation [link]="getUriForStep(8)">{{ 'COMPONENT.mandating.cannot_start.attachments_required' | translate }}</app-explanation>
  }


  @if (showStartMandatingButton()) {
    <div class="start-mandating">
      <vwui-button
        class="is-primary btn-start"
        [appDisabledReason]="startMandateDisabledReason"
        [loading]="isSaving"
        (click)="mandateProject()"
      >{{ 'COMPONENT.mandating.start_mandating' | translate }}</vwui-button>
    </div>
  }

  @if (showStartMandatingButton()) {
    <div>
      <app-mandating-flow-info-card><div class="mce-content-body" [innerHTML]="companyMandatingText"></div></app-mandating-flow-info-card>
    </div>
  }

  @if (showRestartMandatingButton()) {
    <div class="restart-mandating">
      <app-explanation [link]="getUriForStep(1)">
        {{ 'COMPONENT.mandating.failed' | translate : { tisLabelShort: projectDetails.projectInfo.tisLabelShort } }}
        <ng-container actions>
          <vwui-button
            class="is-primary btn-start"
            [appDisabledReason]="restartMandateDisabledReason()"
            [loading]="isSaving"
            (click)="restartMandateProject()"
            >
            {{ 'COMPONENT.mandating.restart_mandating' | translate }}
          </vwui-button>
        </ng-container>
      </app-explanation>
    </div>
  }

  @if (showInExecutionButton()) {
    <div class="to-execution">
      <vwui-button class="is-primary btn-start" [appDisabledReason]="inExecutionDisabledReason()" [loading]="isSaving" (click)="setProjectInExecution()">
        {{ 'COMPONENT.mandating.to_execution' | translate }}
      </vwui-button>
      <vwui-button class="has-warning btn-start" [appDisabledReason]="disabledForTendermanagers()" [loading]="isSavingForArchived" (click)="setProjectToArchived()">
        {{ 'COMPONENT.mandating.to_archived' | translate }}
      </vwui-button>
    </div>
  }

  @if (showMandatingStatus()) {
    <div class="mandate-status">
      <vwui-button class="is-outline" [ngClass]="{'has-warning': projectDetails.status === 'mandating_failed'}">
        {{ getStartDateMandate() | date: ('DATE.short' | translate) }} {{ 'COMPONENT.mandating.mandate_start' | translate }}
      </vwui-button>
      @if (companyMandatingText) {
        <vwui-tooltip class="mandating-info-icon" position="bottom">
          <div class="mandating-info-icon--list-padding mce-content-body mandate-info" slot="label" [innerHTML]="companyMandatingText"></div>
          <vwui-btn-icon icon="info"></vwui-btn-icon>
        </vwui-tooltip>
      }
      <div class="mandate-steps">
        @for (mandateStep of mandateDetails?.mandateSteps; track mandateStep) {
          <div class="mandate-step">
            <div class="mandate-step__content">
              <app-item-status [status]="mandateStep.stepResult">
                <div class="item-user"><vwui-tooltip [label]="mandateStep.actionholderName"><vwui-icon iconName="vwui-user"></vwui-icon></vwui-tooltip></div>
                <div class="item-title">{{ mandateStep.stepTitle }}</div>
                <div class="item-date">{{ mandateStep.stepResultSubmittedAt | date: ('DATE.long' | translate) }}</div>
                @if (mandateStep.remark) {
                  <div class="item-remark">{{ mandateStep.remark }}</div>
                }
              </app-item-status>
            </div>
          </div>
        }
      </div>
    </div>
  }
</div>
